import React from 'react';
import { Button } from '@/components/ui/button';

// Employer forms list a checklist ("Co-Morbid Conditions: Diabetes", "...: Asthma")
// as one checkbox question per option, and staff used to answer each by hand.
// Options of one checklist share a `section` (or, when the scan gave none, the
// label before the ':'); three or more of them are shown together with one-tap
// answers. A human still taps — nothing here answers anything on its own.
const MIN_GROUP = 3;
const groupKey = (q) => (q.answer_type !== 'checkbox' ? ''
  : (q.section || '').trim() || (q.question.includes(':') ? q.question.split(':')[0].trim() : ''));
const isNoneOption = (q) => /^(none|n\/a|not applicable)\.?$/i.test(q.question.split(':').pop().trim());

// [{q}] or [{group: {key, items}}] in first-seen order, so each screen renders
// its own inputs and only wraps the checklists.
export function groupGaps(questions) {
  const counts = {};
  questions.forEach((q) => { const k = groupKey(q); if (k) counts[k] = (counts[k] || 0) + 1; });
  const out = [];
  const seen = {};
  questions.forEach((q) => {
    const k = groupKey(q);
    if (!k || counts[k] < MIN_GROUP) { out.push({ q }); return; }
    if (!seen[k]) { seen[k] = { key: k, items: [] }; out.push({ group: seen[k] }); }
    seen[k].items.push(q);
  });
  return out;
}

// "None of these": every option No, except an option literally labelled None/N/A.
export const noneOfThese = (items) => Object.fromEntries(items.map((q) => [q.id, isNoneOption(q) ? 'Yes' : 'No']));

export function GapChecklist({ group, onSet, disabled, renderItem }) {
  return (
    <div className="space-y-2 rounded-lg border bg-background p-2" data-testid={`gap-checklist-${group.key}`}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-medium">{group.key} ({group.items.length} options)</span>
        <Button size="sm" variant="outline" className="h-7" disabled={disabled}
          onClick={() => onSet(noneOfThese(group.items))} data-testid="gap-checklist-none">
          None of these
        </Button>
        <Button size="sm" variant="ghost" className="h-7" disabled={disabled}
          onClick={() => onSet(Object.fromEntries(group.items.map((q) => [q.id, ''])))} data-testid="gap-checklist-clear">
          Clear
        </Button>
      </div>
      {group.items.map(renderItem)}
    </div>
  );
}
